import * as React from "react";

import { UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";

import CardTitle from "../shared/CardTitle";
import HotelRating from "../shared/HotelRating";
import AddressAndNeighborhood from "../shared/AddressAndNeighborhood";
import PricesAndDate from "../shared/PricesAndDate";
import FlightInfo from "../shared/FlightInfo";
import DescriptionAndGuestReviewSectionWrapper from "../shared/DescriptionAndGuestReviewSectionWrapper";

import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const DefaultCardContents = ({ packageItem, index, language, overImage, grid }: PackageCardProps) => {
  const content = (
    <UitkCardContentSection padded={false}>
      <UitkCardContentSection>
        <UitkLayoutFlex justifyContent="space-between">
          <UitkLayoutFlexItem>
            <UitkText overflow="truncate">
              <CardTitle cardTitle={packageItem.hotelName} />
              <HotelRating rating={packageItem.hotelStarRating} isText={false} />
              <AddressAndNeighborhood packageItem={packageItem} />
            </UitkText>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <UitkText overflow="truncate">
              <PricesAndDate packageItem={packageItem} renderSavingBadge renderDates overImage={overImage} />
            </UitkText>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
        <UitkSpacing margin={{ blockstart: "two" }}>
          <UitkLayoutFlex direction="column">
            <UitkLayoutFlexItem>
              <UitkText overflow="truncate">
                <FlightInfo packageItem={packageItem} />
              </UitkText>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
      </UitkCardContentSection>
      <DescriptionAndGuestReviewSectionWrapper packageItem={packageItem} language={language} renderReviewRating />
      <UitkCardLink>
        <TrackedLink
          className="uitk-card-link"
          rfrr={`card-${index}`}
          data-testid={`packagecard-link-${index}`}
          href={packageItem.shopUrl}
          aria-label={packageItem.hotelName}
          moduleName="packages"
        />
      </UitkCardLink>
    </UitkCardContentSection>
  );
  if (grid) {
    return <UitkLayoutGridItem colSpan={2}>{content}</UitkLayoutGridItem>;
  }

  return content;
};
